module.exports = __webpack_public_path__ + "static/media/DB-Bird_tree.6224154e.png";